<form [formGroup]="form" class="flex flex-col gap-4" (ngSubmit)="submit()">
  <div class="space-y-2">
    <label for="username" class="block font-medium text-sm select-none"
      >Account ID</label
    >

    <mat-form-field class="w-full">
      <input
        matInput
        formControlName="username"
        autocomplete="username"
        enterkeyhint="next"
        id="username"
        type="text"
      />

      <mat-error>Vul je account ID in</mat-error>
    </mat-form-field>
  </div>

  <div class="space-y-2">
    <label for="password" class="block font-medium text-sm select-none"
      >Wachtwoord</label
    >

    <mat-form-field class="w-full">
      <input
        matInput
        formControlName="password"
        autocomplete="current-password"
        enterkeyhint="done"
        id="password"
        type="password"
      />

      <mat-error>Vul je wachtwoord in</mat-error>
    </mat-form-field>
  </div>

  <button mat-flat-button>Inloggen</button>
</form>
